import { CoreFilterCommand, LmsTrainingOrder } from 'generated/CoreApi_v1';
import { TFunction } from 'i18next';
import { IAdvFilterMenuItem } from 'views/general/AdvancedFilter';
import { AdvFilterStandardPicker, IAdvFilterCommand, IAdvFilterDropdown } from 'views/general/AdvancedFilter/interfaces';

///
export const topicMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("lms:Student.Catalog.Filter.TopicsText"),
        title: t("lms:Student.Catalog.Filter.TopicsText"),
        filterCommands: [
            {
                command: CoreFilterCommand.TrainingTopic,
                displayName: t("lms:Student.Catalog.Commands.TopicSpecific"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.TopicHierarchical,
            },
            {
                command: CoreFilterCommand.TrainingCurrentUserTopicInterest,
                displayName: t("lms:Student.Catalog.Commands.TopicYourInterest"),
                canRepeat: false,
                group: 1,
            }
        ]
    };
};

///
export const courseTypeMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("lms:Student.Catalog.Filter.CourseTypeText"),
        title: t("lms:Student.Catalog.Filter.CourseTypeText"),
        filterCommands: [
            {
                command: CoreFilterCommand.TrainingTypeCourseWeb,
                displayName: t("lms:Student.Catalog.Commands.TypeCourseWeb"),
                canRepeat: false,
                group: 1,
            },
            {
                command: CoreFilterCommand.TrainingTypeLive,
                displayName: t("lms:Student.Catalog.Commands.TypedLive"),
                canRepeat: false,
                group: 1,
            },
            {
                command: CoreFilterCommand.TrainingTypeExternalCourse,
                displayName: t("lms:Student.Catalog.Commands.TypeExternalCourse"),
                canRepeat: false,
                group: 1,
            },
            {
                command: CoreFilterCommand.TrainingTypeAssessment,
                displayName: t("lms:Student.Catalog.Commands.TypeAssessment"),
                canRepeat: false,
                group: 1,
            },
            {
                command: CoreFilterCommand.TrainingTypeActivity,
                displayName: t("lms:Student.Catalog.Commands.TypeActivity"),
                canRepeat: false,
                group: 1,
            },
            {
                command: CoreFilterCommand.TrainingTypeLearnPath,
                displayName: t("lms:Student.Catalog.Commands.TypeLearnPath"),
                canRepeat: false,
                group: 2,
            },
            // {
            //     command: CoreFilterCommand.TrainingTypeGame,
            //     displayName: t("lms:Student.Catalog.Commands.TypeGame"),
            //     canRepeat: false,
            //     group: 2,
            // },
        ]
    };
};

///
export const stickersMenuOptions = (t: TFunction, filterCommands: IAdvFilterCommand[], loading: boolean): IAdvFilterDropdown | null => {
    return filterCommands.length == 0 && !loading
        ? null
        : {
            textOrIcon: t("lms:Student.Catalog.Filter.StickersText"),
            title: t("lms:Student.Catalog.Filter.StickersText"),
            filterCommands
        };
};

///
export const periodMenuOptions = (t: TFunction): IAdvFilterDropdown => {

    return {
        textOrIcon: t("lms:Student.Catalog.Filter.PublicationDateText"),
        title: t("lms:Student.Catalog.Filter.PublicationDateText"),
        filterCommands: [
            {
                command: CoreFilterCommand.TrainingPublishPeriod,
                displayName: t("lms:Student.Catalog.Commands.LastWeek"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 1,
            },
            {
                command: CoreFilterCommand.TrainingPublishPeriod,
                displayName: t("lms:Student.Catalog.Commands.LastMonth"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 2,
            },
            {
                command: CoreFilterCommand.TrainingPublishPeriod,
                displayName: t("lms:Student.Catalog.Commands.LastYear"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 3,
            },
            {
                command: CoreFilterCommand.TrainingPublishPeriod,
                picker: AdvFilterStandardPicker.Period,
                displayName: t("lms:Student.Catalog.Commands.PublicationPeriod"),
                displayPreText: t("lms:Student.Catalog.PublicationPeriodText"),
                canRepeat: false,
                canCheck: true,
                group: 1,
            },
        ]
    };
};

export const workloadMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("lms:Student.Catalog.Filter.WorkloadText"),
        title: t("lms:Student.Catalog.Filter.WorkloadText"),
        filterCommands: [
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.Workload5min"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 1,
            },
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.Workload5To30Min"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 2,
            },
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.Workload30To60Min"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 3,
            },
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.Workload1To5Hours"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 4,
            },
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.Workload5To10Hours"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 5
            },
            {
                command: CoreFilterCommand.TrainingWorkload,
                displayName: t("lms:Student.Catalog.Commands.WorkloadOther"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 6
            },
        ]
    };
};

export const otherMenuOptions = (t: TFunction, userIsManager: boolean): IAdvFilterDropdown => {


    const filterCommands: IAdvFilterCommand[] = [
        {
            command: CoreFilterCommand.TrainingWithHideConcludedEnrolls,
            displayName: t("lms:Student.Catalog.Commands.StatusHideConcluded"),
            canRepeat: false,
            group: 1
        },
        {
            command: CoreFilterCommand.TrainingValidateExpiringOrExpired,
            displayName: t("lms:Student.Catalog.Commands.TrainingValidateExpiringOrExpired"),
            canRepeat: false,
            optionGroup: "ExpiringOrExpired",
            group: 2
        },
        {
            command: CoreFilterCommand.TrainingValidateExpired,
            displayName: t("lms:Student.Catalog.Commands.TrainingValidateExpired"),
            canRepeat: false,
            optionGroup: "ExpiringOrExpired",
            group: 2
        },

        {
            command: CoreFilterCommand.TrainingCurrentUserMandatory,
            displayName: t("lms:Student.Catalog.Commands.RequiredTrainings"),
            canRepeat: false,
            canCheck: true,
            group: 3,
        },
        {
            command: CoreFilterCommand.TrainingCurrentUserOptional,
            displayName: t("lms:Student.Catalog.Commands.OptionalTrainings"),
            canRepeat: false,
            canCheck: true,
            group: 3,
        },
        {
            command: CoreFilterCommand.TrainingCurrentUserAssigned,
            displayName: t("lms:Student.Catalog.Commands.AssignedTrainings"),
            canRepeat: false,
            canCheck: true,
            group: 3,
        },
        {
            command: CoreFilterCommand.TrainingBestRated,
            displayName: t("lms:Student.Catalog.Commands.BestRatedTrainings"),
            canRepeat: false,
            canCheck: true,
            group: 3,
        },
        {
            command: CoreFilterCommand.TrainingWithAvailableClassrooms,
            displayName: t("lms:Student.Catalog.Commands.AvaiableClassrooms"),
            canRepeat: false,
            canCheck: true,
            group: 4,
        },
        {
            command: CoreFilterCommand.TrainingStartNow,
            displayName: t("lms:Student.Catalog.Commands.StartNowTrainings"),
            canRepeat: false,
            canCheck: true,
            group: 4,
        }
    ];

    if (userIsManager)
        filterCommands.push(
            {
                command: CoreFilterCommand.TrainingCurrentUserRegisterTeamMembers,
                displayName: t("lms:Student.Catalog.Commands.RegisterTeamMembers"),
                canRepeat: false,
                canCheck: true,
                group: 3,
            });

    return {
        textOrIcon: t("lms:Student.Catalog.Filter.OtherText"),
        title: t("lms:Student.Catalog.Filter.OtherText"),
        filterCommands
    };
};


///
export const orderMenuOptions = (t: TFunction): IAdvFilterMenuItem<LmsTrainingOrder>[] => {
    const options = [
        { text: t("lms:Student.Catalog.Order.Name"), value: LmsTrainingOrder.Name, group: 1 },
        { text: t("lms:Student.Catalog.Order.MostRecent"), value: LmsTrainingOrder.MostRecent, group: 1 },
        { text: t("lms:Student.Catalog.Order.MostSubscribed"), value: LmsTrainingOrder.MostEnrolls, group: 1 },
        { text: t("lms:Student.Catalog.Order.BestRated"), value: LmsTrainingOrder.BestRated, group: 1 },
    ];

    return options;
};
